import React from "react";
import { MdOutlineEmail } from "react-icons/md";
import { RiCheckboxBlankCircleFill } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
const Card = ({ data, handleEditClick }) => {
  return (
    <div
      className="text-black rounded-md border"
      style={{ boxShadow: "rgb(159 157 157 / 24%) 0px 3px 21px" }}>
      <div className="card-body py-5 px-4 gap-1">
        <div className="flex justify-between items-center">
          <h2 className="card-title">{data?.name}</h2>
          {/* <FiEdit onClick={handleEditClick} className=" cursor-pointer" /> */}
        </div>
        <div className="flex justify-normal items-center gap-1">
          <MdOutlineEmail />
          <p className="font-normal mt-[-6px]">{data?.email}</p>
        </div>
        <div className="flex justify-normal items-center gap-2 flex-wrap my-2">
          {data?.techs?.map((tech, i) => {
            return (
              <div
                className="badge bg-[#005DBE] text-white font-medium"
                key={i}>
                {tech?.name}
              </div>
            );
          })}
        </div>
        <div className="flex justify-normal items-center gap-1">
          <RiCheckboxBlankCircleFill
            className={`${
              data?.active === true ? "text-green-500" : "text-red-500"
            }`}
          />
          <p className="font-normal">
            {data?.active === true ? "Active" : "Inactive"}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Card;
